var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 20.1795 5.82046 26 13 26C20.1795 26 26 20.1795 26 13C26 5.81986 20.1795 0 13 0C5.82046 0 0 5.81986 0 13ZM13 9.75C13.8975 9.75 14.625 10.4775 14.625 11.375V20.0417C14.625 20.9391 13.8975 21.6667 13 21.6667C12.1025 21.6667 11.375 20.9391 11.375 20.0417V11.375C11.375 10.4775 12.1025 9.75 13 9.75ZM11.375 5.9581C11.375 5.06071 12.1027 4.33333 13 4.33333C13.8973 4.33333 14.625 5.06071 14.625 5.9581C14.625 6.85596 13.8973 7.58333 13 7.58333C12.1027 7.58333 11.375 6.85596 11.375 5.9581Z",
    fill: "#081e56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.3e3765525d07099b45ea5b6186fdd430.svg";
export { ForwardRef as ReactComponent };